import React, { useContext } from 'react';

import { useSelector } from 'react-redux';

import { ToolbarContext } from '../..';
import { RootState } from '../../../../../../../init-store';
import { SvgImage } from '../../../../../../shared/components';
import { ButtonProps } from '../../../../../../shared/components/button';
import { selectShouldShowDeviceErrorModal } from '../../../../../../shared/features/device-manager/selectors';
import { MediaStatus } from '../../../../constants';
import { BlockedMicrophoneButton } from '../blocked-microphone-button';
import { MutedMicrophoneButton } from '../muted-microphone-button';
import { UnmutedMicrophoneButton } from '../unmuted-microphone-button';
import css from './style.css';

type Props = {
    onToggleMute: ButtonProps['onClick'];
    title?: string;
    status?: MediaStatus;
    buttonProps?: Partial<ButtonProps>;
    testId?: string;
};

const shouldShowSelector = (state: RootState) => selectShouldShowDeviceErrorModal(state, 'audioinput');

export const MicrophoneButton: React.FC<Props> = ({ status = MediaStatus.UNMUTED, onToggleMute, ...rest }) => {
    const { buttonSize } = useContext(ToolbarContext);
    const shouldShowError = useSelector(shouldShowSelector);

    const isBadgeErrorVisible = shouldShowError && status !== MediaStatus.BLOCKED;

    const MicrophoneButtonComponent = (() => {
        switch (status) {
            case MediaStatus.UNMUTED:
                return UnmutedMicrophoneButton;
            case MediaStatus.BLOCKED:
                return BlockedMicrophoneButton;
            case MediaStatus.MUTED:
            default:
                return MutedMicrophoneButton;
        }
    })();

    const props = { ...rest, onClick: onToggleMute, size: buttonSize };
    return (
        <>
            <div className={css.MicrophoneButton}>
                <MicrophoneButtonComponent {...props} />
                {isBadgeErrorVisible ? <SvgImage className={css.BadgeError} imageName="badgeError" /> : null}
            </div>
        </>
    );
};
